export const SAVE_CHANGES_BUTTON_TEXT = 'Guardar cambios';
export const CANCEL_EDIT_BUTTON_TEXT = 'Cancelar';
export const EDIT_BUTTON_TEXT = 'Editar';

export const ERROR_SNACKBAR_DURATION = 5000;
export const SUCCESS_SNACKBAR_DURATION = 3000;
